const current = () => {
  const s = document.querySelector('script[src*="/static/js/main"]');
  return s ? new URL(s.src).pathname : null;
};

export async function updateAvailable() {
  const mine = current();
  if (!mine) return false;
  try {
    const r = await fetch("/asset-manifest.json", { cache: "no-store" });
    if (!r.ok) return false;
    const m = await r.json();
    const latest = m?.files?.["main.js"];
    return Boolean(latest) && new URL(latest, window.location.origin).pathname !== mine;
  } catch {
    return false;
  }
}

export async function applyUpdate() {
  try {
    const regs = await navigator.serviceWorker?.getRegistrations?.();
    await Promise.all((regs || []).map((r) => r.update().catch(() => {})));
    if (window.caches) await Promise.all((await caches.keys()).map((k) => caches.delete(k)));
  } catch { /* ignore */ }
  window.location.reload();
}
